import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { appApi } from '../../../utils/endpoints/appApi';

import http from '../../../services/http';

export const getBanksAction = createAction('app/getBanks');
export const getInboxLettersAction = createAction('app/getInboxLetters');
export const getSentLettersAction = createAction('app/getSentLetters');
export const getDraftLettersAction = createAction('app/getDraftLetters');
export const readLetterAction = createAction('app/readLetter');

export const getBankList = createAsyncThunk(getBanksAction.type, async () => {
    const response = await http.get(appApi.banks);
    return response.data;
});

export const getInboxLetters = createAsyncThunk(getInboxLettersAction.type, async (status, _) => {
    const endpoint = appApi.getInboxLetters + '/' + status;
    const response = await http.get(endpoint);
    return response.data;
});

export const getDraftLetters = createAsyncThunk(getDraftLettersAction.type, async () => {
    const response = await http.get(appApi.getDraftLetters);
    return response.data;
});

export const getSentLetters = createAsyncThunk(getSentLettersAction.type, async () => {
    const response = await http.get(appApi.getSentLetters);
    return response.data;
});

export const readLetter = createAsyncThunk(readLetterAction.type, async (letterId) => {
    const response = await http.get(appApi.readLetter(letterId));
    return response.data;
});




